<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card title="Driving Events" collapse-action refresh-content-action @refresh="closeCardAnimationDemo">
      <vs-table ref="table" pagination :max-items="itemsPerPage" v-if="eventsList" search
        :data="eventsList.reverse() || []">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                      <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  itemsPerPage
                }}
                -
                {{ eventsList.length }}
                </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu  >
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 30">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          </div>
          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th sort-key="data" >Start Time</vs-th>
          <vs-th sort-key="vehicle">Vehicle</vs-th>
          <vs-th sort-key="driver">Driver</vs-th>
          <vs-th sort-key="origin">Origin</vs-th>
          <vs-th sort-key="codriver">Destination</vs-th>
          <vs-th sort-key="duration">Duration</vs-th>
          <vs-th sort-key="distance">Distance</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody class="nmadir">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ tr.data }}
              </vs-td>
              <vs-td>
                {{ tr.vehicle }}
              </vs-td>
              <vs-td>
                <p class="product-category">
                  {{ tr.driver }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  {{ tr.origin + ',' + tr.origin }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  {{ tr.destination }}
                  <!-- <feather-icon icon="WifiIcon" svgClasses="w-5 h-5 text-danger stroke-current" class="ml-6" /> -->
                </p>
              </vs-td>
              <vs-td>
                {{ tr.duration }}
              </vs-td>
              <vs-td class="pr-2">
                {{ tr.distance.toFixed(2) }} miles
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  data() {
    return {
      fileName: "",
      activePrompt: false,
      selected: [],
      // products: [],
      itemsPerPage: 6,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
    };
  },
  computed: {
    products() {
      return this.$store.state.event.products;
    },
    ...mapGetters({
      eventsList: "event/getEvents"
    }),
  },
  methods: {
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(3000);
      setTimeout(() => {
        this.$store.dispatch("event/fetchDataListItems");
      }, 3000);
    },
    getStreetAddressFrom(lat, long) {
      axios.get(
        "https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        lat +
        "," +
        long,
        {
          headers: {
            Authorization: 'AIzaSyDN9VrYOGsPRbtTAcw1FsSq85kO7fStcgU'
          }
        }
      ).then(data => {
        return data.results[0].formatted_address;
      })
    },
  },
  created() {
    this.$store.dispatch("event/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
